<template>
  <div v-if="!showUpdateSideBar" class="p-6 min-w-min h-full flex flex-col bg-white rounded-2xl">
    <!-- title and search bar -->
    <div class="flex flex-row items-center justify-between mb-4">
      <p class="text-3xl font-bold">Pages</p>
    </div>
    <!-- body -->
    <div>
      <table class="table-auto w-full font-light">
        <thead class="border-b-2 border-light-gray">
          <tr class="text-left text-gray text-md">
            <th class="py-2 font-normal text-center">Thumbnail</th>
            <th class="py-2 font-normal">Title</th>
            <th class="py-2 font-normal">Content</th>
            <th class="py-2 font-normal text-center">Type</th>
            <th class="py-2 font-normal text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="contentData in pages" :key="contentData.id" class="text-lg">
            <td>
              <div class="flex justify-center">
                <img class="rounded-lg rectangle_img w-40 object-cover my-2" :src="contentData.thumbnail_image"
                  alt="" />
              </div>
            </td>
            <td class="truncate-2-lines px-2 align-top">
              {{ contentData.title }}
            </td>
            <td class="px-2 w-96 align-top">
              <div class="w-96 truncate-2-lines text-gray" v-html="contentData.content"></div>
            </td>
            <td>
              <div class="flex justify-center">
                <div v-if="contentData.type == '1'">
                  <p>About Us</p>
                </div>
                <div v-if="contentData.type == '2'">
                  <p>Contact Us</p>
                </div>
                <div v-if="contentData.type == '3'">
                  <p>Privacy and Policy</p>
                </div>
                <div v-if="contentData.type == '4'">
                  <p>Become a Member</p>
                </div>
                <div v-if="contentData.type == '5'">
                  <p>Member Benefits</p>
                </div>
                <div v-if="contentData.type == '6'">
                  <p>Terms and Conditions</p>
                </div>
              </div>
            </td>
            <td>
              <div class="flex justify-center relative">
                <Menu>
                  <MenuButton>
                    <EllipsisVerticalIcon class="w-8 h-8 text-black hover:text-blue cursor-pointer" />
                  </MenuButton>
                  <MenuItems class="
                      p-1
                      space-y-1
                      absolute
                      top-8
                      right-0
                      z-50
                      bg-white
                      border border-light-gray
                      shadow-md
                      rounded-lg
                      w-12/12
                    ">
                    <MenuItem @click="handleEdit(contentData.id)"
                      class="hover:bg-light-blue m-1 rounded-md cursor-pointer">
                    <div class="flex flex-row items-center px-4 py-2 min-w-min">
                      <PencilIcon class="text-blue w-5 h-5 mr-4" />
                      <p class="text-blue">Edit</p>
                    </div>
                    </MenuItem>
                  </MenuItems>
                </Menu>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <!-- update page content -->
  <div v-else class="p-6 min-w-min h-full flex flex-col bg-white rounded-2xl">
    <div class="w-full h-full flex flex-col content-between">
      <!-- header -->
      <div class="flex justify-between">
        <div class="flex space-x-2 items-center">
          <div @click="handleUpdateSideBar" class="group p-2 rounded-full hover:bg-light-blue cursor-pointer">
            <ArrowSmallLeftIcon class="w-6 h-6 text-black group-hover:text-blue" />
          </div>
          <h1 class="text-blue md:text-2xl">Update Content</h1>
        </div>
        <div class="min-w-min flex flex-row items-center justify-between space-x-4">
          <BaseRoundedButton v-if="!updateFlag" @click="handleSaveUpdate" class="w-full">
            <p class="hidden md:block">Update Page Detail</p>
            <p class="md:hidden block text-sm">Save</p>
          </BaseRoundedButton>
          <BaseRoundedButton v-else @click="handleSaveUpdate" class="w-full">
            <p>Save Update</p>
          </BaseRoundedButton>
        </div>
      </div>
      <!-- body -->
      <div class="flex flex-col space-y-2">
        <div class="md:flex md:space-x-16 items-center relative">
          <div class="md:w-2/4 w-full relative">
            <div @click="handleFileImport" class="group py-4 cursor-pointer">
              <p class="text-gray mb-2 font-normal">Thumbnail Image</p>
              <!-- hiddden image file input field that triger when profile image container clicked -->
              <input ref="imageFileUploader" class="hidden" type="file" name="profileImage" id="profileImage"
                accept="image/*" @change="handleFileUpload($event)" />
              <div class="flex justify-center">
                <img v-if="thumbnailUrl" class="w-full rectangle_img object-cover rounded-lg mb-2" :src="thumbnailUrl"
                  alt="" />
                <img v-else class="w-full rectangle_img object-cover rounded-lg mb-2"
                  src="https://www.berchielli.co.uk/wp-content/themes/barberry/images/placeholder.jpg" alt="" />
              </div>
              <p v-if="thumbnailUrl" class="
                  cursor-pointer
                  text-center text-lg
                  font-sans
                  text-blue
                  group-hover:underline
                ">
                Change thumbnail image
              </p>
              <p v-else class="
                  cursor-pointer
                  text-center text-lg
                  font-sans
                  text-blue
                  group-hover:underline
                ">
                Add thumbnail image
              </p>
            </div>
            <div v-show="thumbnailUrl" @click="handleClearImage" class="
                flex
                items-center
                justify-center
                p-3
                bg-red
                rounded-full
                absolute
                -right-6
                top-6
                cursor-pointer
              ">
              <TrashIcon class="text-white h-6 w-6" />
            </div>
          </div>
          <div class="md:w-2/4">
            <base-text-input v-model="title" name="title" isAutoComplete="off" label="Title" />
          </div>
        </div>
        <!-- rich text editor -->
        <div class="w-full">
          <p class="text-gray">Content</p>
          <vue-editor useCustomImageHandler @imageAdded="handleImageAdded" v-model="content" class="min-h-full mb-6" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userService from "../Services/user.service";
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";
import VueEditor from "../components/BaseQuillEditor.vue";
import {
  EllipsisVerticalIcon,
  PencilIcon,
  TrashIcon,
  ArrowSmallLeftIcon,
} from "@heroicons/vue/24/outline";
import BaseRoundedButton from "../components/BaseRoundedButton.vue";
import BaseTextInput from "../components/BaseTextInput.vue";
import { useToast } from "vue-toastification";
export default {
  name: "ManangPage",
  components: {
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    EllipsisVerticalIcon,
    PencilIcon,
    TrashIcon,
    BaseRoundedButton,
    BaseTextInput,
    ArrowSmallLeftIcon,
    VueEditor,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      showUpdateSideBar: false,
      tempId: "",
      thumbnailUrl: "",
      imageFile: "",
      title: "",
      content: "",
      type: "",
      pages: [],
    };
  },
  methods: {
    getPages() {
      userService.getPage().then((response) => {
        this.pages = response.data.data;
      });
    },
    getPageDetail(id) {
      userService.getPageDetail(id).then((response) => {
        this.title = response.data.data.title;
        this.content = response.data.data.content;
        this.type = response.data.data.type;
        this.thumbnailUrl = response.data.data.thumbnail_image;
      });
    },
    handleUpdateSideBar() {
      this.showUpdateSideBar = !this.showUpdateSideBar;
    },
    handleEdit(pageId) {
      this.handleUpdateSideBar();
      this.tempId = pageId;
      this.getPageDetail(pageId);
    },
    handleFileImport() {
      this.$refs.imageFileUploader.click();
    },
    handleFileUpload(event) {
      this.imageFile = event.target.files[0];
      this.thumbnailUrl = URL.createObjectURL(this.imageFile);
    },
    handleClearImage() {
      this.thumbnailUrl = "";
      this.imageFile = "";
    },
    handleImageAdded(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData();
      formData.append("image", file);

      userService
        .storeImage(formData)
        .then((response) => {
          const url = response.data.data.url;
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSaveUpdate() {
      let formData = new FormData();
      if (this.imageFile || !this.thumbnailUrl) {
        formData.append("thumbnail_image", this.imageFile);
      }
      formData.append("title", this.title);
      formData.append("content", this.content);
      formData.append("status", "1");

      userService
        .storeUpdatePage(this.tempId, formData)
        .then(() => {
          this.$Progress.finish();
          this.tempId = "";
          this.thumbnailUrl = "";
          this.imageFile = "";
          this.title = "";
          this.content = "";
          this.type = "";
          this.getPages();
          this.showUpdateSideBar = !this.showUpdateSideBar;
          this.toast.success("Update content successful.");
        })
        .catch((error) => {
          console.log(error);
          this.$Progress.fail();
          this.toast.error("Error! Cannot update content.");
        });
    },
  },
  created() {
    this.$Progress.start();
    this.getPages();
  },
  mounted() {
    this.$Progress.finish();
  },
};
</script>

<style scoped>
.rectangle_img {
  aspect-ratio: 16/9;
}

.truncate-2-lines {
  max-height: 3.6em;
  /* double the size of line-height */
  line-height: 1.8em;
  text-overflow: ellipsis;
  word-wrap: break-word;
  overflow: hidden;
}
</style>
